import { PipeTransform, Pipe } from '@angular/core';
import Company from '../model/company/company';
import ProjectContact from '../model/company/projectContact';
import Contact from '../model/Contact/contact';

@Pipe({
  name: 'groupProjectContacts'
})
export class GroupProjectContactPipe implements PipeTransform {
  transform(projectContacts: ProjectContact[]): ProjectContactGroup[] {
    if (projectContacts == null || projectContacts.length === 0) {
      return [];
    }

    let toReturn: ProjectContactGroup[] = [];

    for (let projectContact of projectContacts) {
      if (projectContact.company == null || projectContact.contact == null) {
        continue;
      }
      let projectContactGroup = toReturn.find(
        pcg => pcg.company.id === projectContact.company.id
      );
      if (projectContactGroup == null) {
        projectContactGroup = { company: projectContact.company, contacts: [] };
        toReturn.push(projectContactGroup);
      }
      if (
        projectContact.contact.contactUserId == null &&
        projectContact.contactUserId != null
      ) {
        projectContact.contact.contactUserId = projectContact.contactUserId;
      }
      projectContactGroup.contacts.push(projectContact.contact);
    }

    return toReturn;
  }
}

export interface ProjectContactGroup {
  company: Company;
  contacts: Contact[];
}
